// src/modules/restaurant/pages/orders/components/OrderDetails/OrderSummary.tsx
import React from "react";
import { OrderList } from "../../types/orderTypes";
import { useUser } from "src/business-types/grocery/components/UserContext";

interface Props {
  selectedOrder: OrderList;
  themeTextColor: string;
  getLightBgClass: () => string;
}

const OrderSummary: React.FC<Props> = ({ selectedOrder, themeTextColor, getLightBgClass }) => {
  const { userConfigration } = useUser();
  const toBoolean = (value: any) =>value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  const summaryItems = [
    { label: "Subtotal", value: selectedOrder.totalAmount.toFixed(2) || 0.0 },
    ...(deliveryFeeEnabled
    ? [
        {
          label: "Delivery Fee",
          value: selectedOrder.deliveryFee?.toFixed(2) || 0.0,
        },
      ]
    : []),
    { label: "Discount", value: selectedOrder.discount.toFixed(2) || 0.0 },
  ];

  return (
    <div className={`${getLightBgClass()} rounded-xl border border-gray-200 p-2 mb-3`}>
      <h3 className={`text-lg font-semibold ${themeTextColor} mb-2 flex items-center gap-2`}>
        <i className="fas fa-receipt text-sm"></i> Order Summary
      </h3>

      {summaryItems.map((item, index) => (
        <div key={index} className="flex justify-between items-center py-1 ">
          <span className="font-medium text-sm">{item.label}</span>
          <span className={`font-semibold ${themeTextColor} text-sm`}>{item.value}</span>
        </div>
      ))}

      <div className="border-b border-gray-300 my-1.5"></div>

      <div className="flex justify-between items-center pt-1">
        <span className="text-lg font-bold">Total</span>
        <span className={`text-xl font-bold ${themeTextColor}`}>{selectedOrder.Finalamount}</span>
      </div>
    </div>
  );
};

export default OrderSummary;
